import React from "react";
import MainComponent from "../../../components/ui_comps/MainComponent";
import { bgColor } from "../../../../utility/constants/colorManager";

const SupportIndex = () => {
  return (
    <div
      style={{
        width: "100%",
        overflow: "scroll",
        boxSizing: "border-box",
        backgroundColor: bgColor,
      }}
    >
      <div style={{ backgroundColor: "white", width: "100%", height: "100%" }}>
        <MainComponent
          filterRequired={false}
          headerTitle="Support"
          headerStyle={{
            fontSize: "20px",
          }}
          onClickFilterCall={(data) => {}}
        />
        <div style={{ marginLeft: "20px" }}>
          <p style={{ fontSize: "20px", fontWeight: 500, marginBottom: "5px" }}>
            Email:{" "}
            <span style={{ marginLeft: "5px" }}>support@neokred.tech</span>
          </p>
          <p style={{ fontSize: "20px", fontWeight: 500 }}>
            Contact: <span style={{ marginLeft: "5px" }}>+91-9538495000</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportIndex;
